'use client';

import {Accordion, Box, styled} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {StyledSectionContainer} from '@/components/sections/shared/Section.styles';

export const AgendaSectionContainer = styled(StyledSectionContainer)(({theme}) => ({
  color: theme.palette.text.dark,
  paddingBottom: theme.spacing(3),
}));

export const StyledAgendaAccordion = styled(Accordion)(({theme}) => ({
  backgroundColor: theme.palette.background.grey,
  color: theme.palette.text.dark,
  marginBottom: theme.spacing(2),
  '&, &:first-of-type, &:last-of-type': {
    borderRadius: theme.shape.borderRadiusLg,
  },
  '&::before': {
    display: 'none',
  },
}));

export const StyledExpandMoreIcon = styled(ExpandMoreIcon)(({theme}) => ({
  color: theme.palette.text.dark,
}));

export const AgendaSummaryContent = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: theme.spacing(2),
  width: '100%',
}));

export const AgendaSummaryAvatar = styled(Box)({
  position: 'relative',
  width: 56,
  height: 56,
  borderRadius: '50%',
  overflow: 'hidden',
  flexShrink: 0,
});

export const AgendaItemRow = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: theme.spacing(3),
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  '& + &': {
    borderTop: `1px solid ${theme.palette.background.darkGrey}`,
  },
}));

export const AgendaItemDate = styled(Box)(({theme}) => ({
  flexShrink: 0,
  flexGrow: 0,
  width: 170,
  paddingRight: theme.spacing(3),
  borderRight: `1px solid ${theme.palette.background.darkGrey}`,
  alignSelf: 'stretch',
  whiteSpace: 'nowrap',
  [theme.breakpoints.down('sm')]: {
    width: 130,
    paddingRight: theme.spacing(2),
  },
}));

export const AgendaItemBody = styled(Box)({
  flex: 1,
  minWidth: 0,
});
